import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { useHistory, Redirect } from 'react-router-dom';
import {
  Container,
  TitlePage,
  Card,
  TitleCard,
  Order,
  DesktopDetails,
  DesktopGridDetails,
  CloseIconStyled,
  FlexAlign,
} from './styles';
import {
  Text,
  Division,
  Details,
  ItemsSummary,
} from '~/components/pages/Order/Summary/styles';
import Loading from '~/components/layout/Loading';
import close from '~/assets/images/close.png';
import caminhaoBranco from '~/assets/images/Caminhao_Branco.png';
import api from '~/services/api';
import '~/components/styles/Global.css';
import IconProduct from '~/components/layout/IconProduct';
import CancelOrder from '~/components/pages/OrderList/CancelOrder';
import { verifyRoles } from '~/utils/functions/verifyRoles';
import TimelineSteps from '~/components/layout/TimelineSteps';
import { handleStatusText } from '~/utils/functions/mapperStatusOrder';

export default function StatusOrder() {
  const history = useHistory();
  const dispatch = useDispatch();
  const orders = useSelector(state => state.statusReducer.orders);
  const statusReducer =  useSelector((state) => state.statusReducer);
  const loadingCancel = useSelector(state => state.statusReducer.loadingCancel);

  const [products, setProducts] = useState([]);
  const [orderSelected, setOrderSelected] = useState(null);
  const [loadingPage, setLoadingPage] = useState(true);
  const [buttonCanceledShow, setButtonCanceledShow] = useState(false);
  const [canceled, setCanceled] = useState(false);
  const [stepsInfo, setStepsInfo] = useState({
    date: "",
    description: ""
  });
  const roles = useSelector(state => state.rolesReducer.roles);

  const getProducts = selectedOrder => {
    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem('access_token'),
    };
    const parameters = {
      method: 'GET',
      headers: header,
    };
    const urlProducts = `/residential/store/v1/stores/${localStorage.getItem(
      'storeId',
    )}/business-characteristics`;
    api
      .get(urlProducts, parameters)
      .then(res => {
        let products = [];
        res.data.supplyBranches.map(branch => {
          if (branch.name === selectedOrder.supplyBranche) {
            setProducts(branch.products);
            products = branch.products;
          }
          return products;
        });
        if (products.length < 1) {
          setProducts();
        }
        selectedOrder.products.map(order => {
          products.map(product => {
            if (order.code === product.code) {
              dispatch({ type: 'LOADING_CANCEL', loadingCancel: false });
            }
            return order;
          });
          return products;
        });
      })
      .catch(err => {
        setLoadingPage(false);
      });
  };

  const showOrNotCancelButton = selectedOrder => {
    let today = moment(new Date()).format('DD/MM/YYYY HH:mm');
    if (
      selectedOrder.status === 'AGUARDANDO ANÁLISE DO FINANCEIRO' ||
      selectedOrder.status ===
        'AGUARDANDO APROVAÇÃO DA LOGÍSTICA PARA INCLUSÃO NA PROGRAMAÇÃO' ||
      selectedOrder.status ===
        'AGUARDANDO APROVAÇÃO DO CONSULTOR COMERCIAL PARA INCLUSÃO NA PROGRAMAÇÃO'
    ) {
      setButtonCanceledShow(false);
      if (today > moment(selectedOrder.cutDate).format('DD/MM/YYYY HH:mm')) {
        setButtonCanceledShow(true);
      }
    } else {
      setButtonCanceledShow(true);
    }
  };

  const handleOrderCycle = (status, statusFromApi, occupationStatus) => {
    switch (status.toLowerCase()) {
      case 'em análise pelo financeiro':
        {
          dispatch({
            type: "SET_STATUSORDER",
            order: {
              step: '2',
              titleStatus: 'Financeiro',
              status: status,
              occupationStatus: occupationStatus && occupationStatus,
              statusFromApi: statusFromApi,
              cancel: false
            }
          })
        }
        break;
      case 'pedido recebido aguardando análise':
        {
          dispatch({
            type: "SET_STATUSORDER",
            order: {
              step: '1',
              titleStatus: 'Pedido',
              status: status,
              occupationStatus: occupationStatus && occupationStatus,
              statusFromApi: statusFromApi,
              cancel: false
            }
          })
        }
        break;
      case 'aguardando aprovação da logística':
        {
          dispatch({
            type: "SET_STATUSORDER",
            order: {
              step: '1',
              titleStatus: 'Pedido',
              status: status,
              occupationStatus: occupationStatus && occupationStatus,
              statusFromApi: statusFromApi,
              cancel: false
            }
          })
        }
        break;
      case 'não liberado pelo financeiro':
        {
          dispatch({
            type: "SET_STATUSORDER",
            order: {
              step: '2',
              titleStatus: 'Financeiro',
              status: status,
              occupationStatus: occupationStatus && occupationStatus,
              statusFromApi: statusFromApi,
              cancel: true
            }
          })
        }
        break;
      case 'pedido com restrição':
        {
          dispatch({
            type: "SET_STATUSORDER",
            order: {
              step: '2',
              titleStatus: 'Financeiro',
              status: status,
              occupationStatus: occupationStatus &&occupationStatus,
              statusFromApi: statusFromApi,
              cancel: true
            }
          })
        }
        break;
      case 'pedido liberado pelo financeiro':
        if (!occupationStatus) {
          dispatch({
            type: "SET_STATUSORDER",
            order: {
              step: '2',
              titleStatus: 'Financeiro',
              status: status,
              occupationStatus: occupationStatus && occupationStatus,
              statusFromApi: statusFromApi,
              cancel: false
            }
          })
        } else if (occupationStatus && occupationStatus.toLowerCase() === 'nota fiscal liberada') {
          dispatch({
            type: "SET_STATUSORDER",
            order: {
              step: '4',
              titleStatus: 'Liberação',
              status: 'NOTA FISCAL LIBERADA',
              occupationStatus: occupationStatus && occupationStatus,
              statusFromApi: statusFromApi,
              cancel: false
            }
          })
        } else if (
          occupationStatus && occupationStatus.toLowerCase() === 'saida do veículo realizada'
        ) {
          dispatch({
            type: "SET_STATUSORDER",
            order: {
              step: '5',
              titleStatus: 'Saída',
              status: 'SAÍDA DO VEÍCULO REALIZADA',
              occupationStatus: occupationStatus && occupationStatus,
              statusFromApi: statusFromApi,
              cancel: false
            }
          })
        } else if (occupationStatus && occupationStatus.toLowerCase() === 'aguardando emissão de nota fiscal' ||
                   occupationStatus && occupationStatus.toLowerCase() === 'aguardando faturamento') {
          dispatch({
            type: "SET_STATUSORDER",
            order: {
              step: '3',
              titleStatus: 'Faturamento',
              status: status,
              occupationStatus: occupationStatus && occupationStatus,
              statusFromApi: statusFromApi,
              cancel: false
            }
          })
        } else if (occupationStatus && occupationStatus.toLowerCase() === 'caminhão com restrição') {
          dispatch({
            type: "SET_STATUSORDER",
            order: {
              step: '3',
              titleStatus: 'Faturamento',
              status: status,
              occupationStatus: occupationStatus && occupationStatus,
              statusFromApi: statusFromApi,
              cancel: true
            }
          })
        }
        break;
      case 'pedido cancelado':
        {
          dispatch({
            type: "SET_STATUSORDER",
            order: {
              step: '1',
              titleStatus: 'Pedido',
              status: status,
              occupationStatus: occupationStatus && occupationStatus,
              statusFromApi: statusFromApi,
              cancel: true
            }
          })
        }
        break;

      default: {}
    }
  };

  function isStatusCanceled(status, occupationStatus) {
    if(status === "CANCELADO") {
      return true
    } else if(status === "NÃO LIBERADO PELO FINANCEIRO") {
      return true
    } else if(occupationStatus) {
      if(status === "LIBERADO" && occupationStatus === "CAMINHÃO COM RESTRIÇÃO") {
        return true
      }
    } else {
      return false
    }
  }

  function firstLetterUppercase(str){
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  useEffect(() => {
    dispatch({ type: 'ORDER_EDIT_DONE' });
    dispatch({ type: 'LOADING_CANCEL', loadingCancel: true });
    dispatch({ type: 'CANCELED_ORDER', cancelOrder: false });
    let search = window.location.search;
    var text = search.slice(4, 50);
    let selectedOrder = null;
    orders.map(order => {
      if (text === order.id) {
        setOrderSelected(order);
        selectedOrder = order;
      }
    });
    let statusText = handleStatusText(selectedOrder.status)
    let ocupation = selectedOrder.occupationStatus ? selectedOrder.occupationStatus : null;
    let description = selectedOrder.occupationStatus ? selectedOrder.occupationStatus : selectedOrder.cycleStatus
    description = description.toLowerCase()
    description = description[0].toUpperCase() + description.substr(1)
    const verifySteps = [
      'em análise pelo financeiro',
      'pedido recebido aguardando análise',
      'aguardando aprovação da logística'
    ]
    setStepsInfo({
      dateBegin: selectedOrder.creationDate,
      dateEnd: selectedOrder.shipping.departureDate,
      description: verifySteps.includes(statusText.toLowerCase()) ? firstLetterUppercase(statusText.toLowerCase()) : description
    })
    handleOrderCycle(
      statusText,
      selectedOrder.status,
      ocupation
    );
    setCanceled(
      isStatusCanceled(
        selectedOrder.status,
        selectedOrder.occupationStatus
      )
    );
    showOrNotCancelButton(selectedOrder);
    getProducts(selectedOrder);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (loadingCancel) {
      setLoadingPage(true);
    } else {
      setLoadingPage(false);
    }
  }, [loadingCancel]);

  const Products = element => {
    let productName = '';
    products.map(product => {
      if (product.code === element.element.code) {
        productName = product.name;
      }
    });
    return <>{productName}</>;
  };

  const getEspecificProduct = element => {
    let productName = '';
    products.map(product => {
      if (product.code === element.code) {
        productName = product.name;
      }
    });
    return productName;
  };

  return (
    <Container>
      {verifyRoles(roles, 'STATUS_DO_PEDIDO') ? (
        <>
          <TitlePage>
            <div>
              <img src={caminhaoBranco} alt="Ícone caminhão branco" />
              <span>Status do pedido</span>
            </div>
            <CloseIconStyled
              src={close}
              alt="Ícone de fechar"
              onClick={() => history.push('/status')}
            />
          </TitlePage>
          {loadingPage ? (
            <Loading loadingColor={'white'} />
          ) : (
            <Card>
              <DesktopDetails>
                <TitleCard>Detalhes do pedido</TitleCard>
                <Order>
                  <h4>Pedido {orderSelected.number}</h4>
                </Order>
              </DesktopDetails>

              <ItemsSummary style={{ marginTop: '1rem' }}>
                {orderSelected.products.map((item, index) => {
                  return (
                    <Division key={index + 1}>
                      <FlexAlign>
                        <div>
                          <Text>Item {index + 1}</Text>
                          <span style={{ color: '#000FFF', fontSize: '14px' }}>
                            <IconProduct
                              productName={getEspecificProduct(item)}
                              styles={{
                                p2: { width: '15%', margin: '0 .3rem .1rem 0' },
                                p5: { width: '13%', margin: '0 .3rem .1rem 0' },
                                p20: { width: '9%', margin: '0 .3rem .1rem 0' },
                                p45: { width: '9%', margin: '0 .3rem .1rem 0' },
                                p90: { width: '9%', margin: '0 .3rem .1rem 0' },
                                p13: { width: '13%', margin: '0 .3rem .1rem 0' },
                              }}
                            />
                            <Products element={item} />
                          </span>
                        </div>
                        <div>
                          <Text>Quantidade</Text>
                          <Text>
                            <strong
                              style={{
                                fontSize: '14px',
                                marginTop: '-3px',
                                display: 'block',
                                marginBottom: '12px',
                              }}
                            >
                              {item.quantity}
                            </strong>
                          </Text>
                        </div>
                      </FlexAlign>
                    </Division>
                  );
                })}
              </ItemsSummary>
              <Details>
                <TitleCard>Detalhes</TitleCard>
                <DesktopGridDetails>
                  <div>
                    <Text>
                      <strong>Tipo de Pedido</strong>
                      <p>
                        {orderSelected.serviceType === 'ENTREGA'
                          ? 'Entrega'
                          : 'Retira'}
                      </p>
                    </Text>
                    <Text>
                      <strong>Origem do pedido</strong>
                      <p>{orderSelected.source}</p>
                    </Text>
                  </div>
                  <div>
                    <Text>
                      <strong>Data da necessidade</strong>
                      <p>
                        {moment(
                          orderSelected.deliveryDate,
                          'YYYY-MM-DD',
                        ).format('DD/MM/YYYY')}
                      </p>
                    </Text>
                    <Text>
                      <strong>Filial</strong>
                      <p>{orderSelected.supplyBranche}</p>
                    </Text>
                  </div>
                </DesktopGridDetails>

                <TimelineSteps
                  colortemp="#A440E3"
                  stepsInfo={stepsInfo}
                  title={statusReducer.ordersStatus.titleStatus}
                  canceled={canceled}
                />
              </Details>
              <CancelOrder
                buttonCanceledShow={buttonCanceledShow}
                orderSelected={orderSelected}
              />
            </Card>
          )}
        </>
      ) : (
        <Redirect to="/portal" />
      )}
    </Container>
  );
}
